import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'; // HERE
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { CodingComponent } from '../rules/Coding/coding.component';
import { AutoPassComponent } from '../rules/AutoPass/autopass.component';
import { AuthInterceptorService } from '../core/auth-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChartsModule } from '@progress/kendo-angular-charts';
import {RuleService} from './service/rule.service';
import {AutopassService} from './AutoPass/service/autopass.service';
import {InvoiceManagementService} from './InvoiceManagement/service/invoicemanagement.service';
import {TmsService} from './TMS/service/tms.service';
import {CodingService} from './Coding/service/coding.service';
import {ProductionService} from './Production/service/production.service';
import {CTQueryModule} from '../commoncomponent/QueryBuilder/ctquerybuilder.module';
import { QueryBuilderModule } from '../commoncomponent/QueryBuilderAutopass/angular2-query-builder.module';

import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';

import {RPropertiesModule} from '../commoncomponent/RuleProperties/ruleproperties.module';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule,ExcelModule } from '@progress/kendo-angular-grid';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DragulaModule } from 'ng2-dragula';
import { RuleDashboardComponent } from './Dashboard/ruledashboard.component';
import { InvoiceManagementComponent } from './InvoiceManagement/invoicemanagement.component';
import { ProductionComponent } from './Production/production.component';
import { TMSComponent } from './TMS/tms.component';
import { WindowModule  } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { TabsComponent } from './DynamicTab/tabs.component';
import { TabComponent } from './DynamicTab/tab.component';
import { DynamicTabsDirective } from './DynamicTab/dynamic-tabs.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { CodingFormComponent } from '../rules/Coding/codingform.component';
import { AutopassFormComponent } from '../rules/AutoPass/autopassform.component';
import { StarterModule } from '../starter/starter.module';
import { UploadModule } from '@progress/kendo-angular-upload';
import { AttachDocumentModalComponent } from './modal/attachDocument.component';
import {MessageBox} from '../commoncomponent/MessageBox/MessageBox';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { JwPaginationModule } from 'jw-angular-pagination';
import { TabComponentAutopass } from './DynamicTab/tab.componentAuotpass';
import { TabsComponentAutopass } from './DynamicTab/tabs.componentAutopass';
import { ValidationComponent } from './validation/validation.component';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { ValidationForm } from './validation/validation-form/validation-form';
import { ValidationService } from './validation/service/validation-service';
import { AuthRouteGuard } from '../core/auth-route-guard';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthRouteGuard],
    data: {
      title: 'Rule-Dashboard',
      parent: 'rules',
      urls: [
        { title: 'Rule-Dashboard', url: '/rules/ruledashboard' }
      ]
    },
    children: [
      {
        path: 'ruledashboard',
        data: {
          parent: 'rules'
        },
        component: RuleDashboardComponent
      }]
  },
  {
    path: '',
    data: {
      title: 'Rules-Coding',
      urls: [
        { title: 'Rules-Coding', url: '/rules/coding'}
      ]
    },
    children: [
      {
        path: 'coding',
        data: {
          parent: 'rules'
        },
        component: CodingComponent
      }]
  },
  {
    path: '',
    data: {
      title: 'Rules-AutoPass',
      urls: [
        { title: 'Rules-AutoPass', url: '/rules/autopass'}
      ]
    },
    children: [
      {
        path: 'autopass',
        data: {
          parent: 'rules'
        },
        component: AutoPassComponent
      }]
  },
  {
    path: '',
    data: {
      title: 'Rules-InvoiceManagement',
      urls: [
        { title: 'Rules-InvoiceManagement', url: '/rules/invoicemanagement'}
      ]
    },
    children: [
      {
        path: 'invoicemanagement',
        data: {
          parent: 'rules'
        },
        component: InvoiceManagementComponent
      }]
  },
  {
    path: '',
    data: {
      title: 'Rules-Production',
      urls: [
        { title: 'Rules-Production', url: '/rules/production'}
      ]
    },
    children: [
      {
        path: 'production',
        data: {
          parent: 'rules'
        },
        component: ProductionComponent
      }]
  },
  {
    path: '',
    data: {
      title: 'Rules-TMS',
      urls: [
        { title: 'Rules-TMS', url: '/rules/tms'}
      ]
    },
    children: [
      {
        path: 'tms',
        data: {
          parent: 'rules'
        },
        component: TMSComponent
      }]
  },
  {
    path: '',
    data: {
      title: 'Validation',
      urls: [
        { title: 'Validation', url: '/rules/validation'}
      ]
    },
    children: [
      {
        path: 'validation',
        data: {
          parent: 'rules'
        },
        component: ValidationComponent
      }]
  }
];

@NgModule({
    bootstrap: [
        CodingComponent,
        AutoPassComponent,
        RuleDashboardComponent,
        InvoiceManagementComponent,
        ProductionComponent,
        TMSComponent,
        TabsComponent,
        TabComponent,
        TabComponentAutopass,
        TabsComponentAutopass,
        ValidationForm
    ],
    imports: [
        FormsModule,
        UploadModule,
        CommonModule, ChartsModule,
        CTQueryModule,
        QueryBuilderModule,
        RPropertiesModule,
        LayoutModule,
        GridModule,
        RouterModule.forChild(routes),
        TreeViewModule,
        DialogModule,
        DragulaModule.forRoot(),
        NgxJsonViewerModule,
        WindowModule,
        InputsModule,
        ExcelModule,
        NotificationModule,
        ReactiveFormsModule,
        StarterModule,
        JwPaginationModule,
        NgbModule,
        NzTabsModule,
        NzGridModule,
        NzFormModule,
        HttpClientModule,
        NzTableModule,
        NzIconModule,
        NzNotificationModule,
        NzCheckboxModule,
        NzPopconfirmModule,
        NzInputModule
    ],
    declarations: [
        CodingComponent,
        AutoPassComponent,
        RuleDashboardComponent,
        InvoiceManagementComponent,
        ProductionComponent,
        TMSComponent,
        TabsComponent,
        TabComponent,
        TabComponentAutopass,
        TabsComponentAutopass,
        CodingFormComponent,
        AutopassFormComponent,
        DynamicTabsDirective,
        AttachDocumentModalComponent,
        ValidationComponent,
        ValidationForm
    ],
    providers: [
        RuleService,
        CodingService,
        TmsService,
        InvoiceManagementService,
        ProductionService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        MessageBox,
        AutopassService,
        ValidationService
    ]
})
export class RuleModule {}

